import { getArtigosRecentes } from "@/lib/blog.functions";
import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/seo/JsonLd";
import { EsteticaRegenerativa, faq } from "@/components/itv/pages/EsteticaRegenerativa";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import { getSiteData } from "@/lib/site-data.functions";
import {
  breadcrumbSchema,
  faqSchema,
  medicalWebPageSchema,
  physicianSchema,
  type Trilha,
} from "@/lib/schema";

const PATH = "/tratamentos/estetica-regenerativa/";
const TITLE = "Estética Integrada e Medicina Regenerativa | Dr. Thiago Viana";
const DESCRIPTION =
  "Cuidado estético conduzido por médico, aliando tecnologias como Mesoject e Unyque Pro ao equilíbrio metabólico e à saúde da pele de dentro para fora.";

export const Route = createFileRoute("/tratamentos/estetica-regenerativa")({
  loader: async () => {
    const [site, head, artigos] = await Promise.all([getSiteData(), carregarPaginaSimples(PATH, TITLE, DESCRIPTION), getArtigosRecentes()]);
    return { site, artigos, ...head };
  },
  staticData: { declaraPhysician: true },
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  const { site, artigos } = Route.useLoaderData();
  const trilha: Trilha[] = [
    { nome: "Home", path: "/" },
    { nome: "Tratamentos", path: "/tratamentos/" },
    { nome: "Estética integrada", path: PATH },
  ];

  return (
    <>
      <EsteticaRegenerativa artigos={artigos} />
      <JsonLd data={medicalWebPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION })} />
      <JsonLd data={breadcrumbSchema(trilha)} />
      <JsonLd data={faqSchema(faq)} />
      <JsonLd data={physicianSchema(site.doctor, "completa")} />
    </>
  );
}
